<template>
  <div class="comment-container">
    <img class="img" :src="imgUrl">
    <span class="comment-view">
      <span class="name">{{ comment.user_name }}</span>
      <span class="comment">{{ comment.comment === '' ? '该用户没有填写评论信息' : comment.comment }}</span>
    </span>
    <Stars :stars="Math.ceil(comment.score / 2)"/>
  </div>
</template>

<script>
import Stars from '@/components/common/stars'

export default {
  name: 'Comment',
  components: {
    Stars
  },
  props: {
    name: {
      type: String,
      default: '小菜鸟'
    },
    stars: {
      type: Number,
      default: 4
    },
    imgUrl: {
      type: String,
      default: require('../../../static/img/header/user_icon.png')
    },
    comment: {
      type: Object,
      default: {}
    }
  }
}
</script>

<style lang="less" scoped>
.comment-container {
  width: 460px;
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
  border-bottom: 1px solid #e0e0e0;
  .img {
    width: 40px;
    height: 40px;
    display: inline-block;
  }
  .comment-view {
    width: 300px;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    .name {
      font-size: 18px;
      color: #333333;
      display: inline-block;
    }
    .comment {
      font-size: 14px;
      color: #999999;
      display: inline-block;
      margin-bottom: 20px;
    }
  }
  .stars {
    width: 120px;
    height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .star {
      width: 14px;
      height: 14px;
      margin: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/meals/comment.vue